export interface LegalHoldBannerProps {
  active: boolean;
}

export function LegalHoldBanner({ active }: LegalHoldBannerProps) {
  if (!active) return null;

  return (
    <div
      role="alert"
      aria-live="polite"
      className="flex items-center gap-3 border-b border-accent-rose/40 bg-accent-rose/10 px-6 py-3 text-sm text-accent-rose"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
        fill="currentColor"
        className="h-4 w-4 shrink-0"
        aria-hidden="true"
      >
        <path
          fillRule="evenodd"
          d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
          clipRule="evenodd"
        />
      </svg>
      <span>
        A legal hold is in effect on this account. Data deletion and account changes may be
        restricted. Contact your legal counsel for details.
      </span>
    </div>
  );
}
